export default __webpack_public_path__ + "static/media/icon-moon2.d6fec174.svg";